const marqueeItems = document.querySelectorAll('[data-marquee-item]')

marqueeItems.forEach(calculateQuantity)

function calculateQuantity($marqueeItem) {
  const itemWidth = $marqueeItem.offsetWidth
  const parentWidth = $marqueeItem.parentElement.offsetWidth
  const quantity = Math.ceil(parentWidth / itemWidth)

  for (let i = 0; i < quantity; i++) {
    addNewItem($marqueeItem)
  }
}

function addNewItem($marqueeItem) {
  const $newItem = $marqueeItem.cloneNode(true)

  $newItem.setAttribute('aria-hidden', true)
  $marqueeItem.insertAdjacentElement('afterend', $newItem)
}
